import React, { FormEvent, useState } from 'react';
import { Button } from '@mui/material';
import { toast } from 'react-toastify';
import Appbar from 'components/appbar/Appbar';
import InsideSaving from 'components/loading/InsideSaving';
import {
  ContentPad,
  PageShell,
  RecordFooter,
  RecordHeader,
  StyledForm,
  WorkArea,
} from 'components/record-shell/RecordShell';
import { api } from 'services/api';
import history from 'services/history';
import { PaymentMethod } from 'types/paymentMethod';
import PaymentMethodForm, { PaymentMethodErrors, validatePaymentMethod } from '../form/PaymentMethodForm';

const NewPaymentMethod: React.FC = () => {
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState<PaymentMethodErrors>({});
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>({
    id: 0,
    name: '',
    active: true,
    max_installments: 1,
    type: '',
  });

  function goBack() {
    history.push('/payment-methods');
  }

  function handleChange(index: keyof PaymentMethod, value: string | number) {
    setPaymentMethod(prev => ({ ...prev, [index]: value }));
  }

  function handleSubmit() {
    setSaving(true);

    api
      .post('/payment-methods', paymentMethod)
      .then(response => {
        toast.success('Forma de recebimento cadastrada');
        // abre a forma recém-cadastrada
        history.push(response.data?.id ? `/payment-methods/${response.data.id}` : '/payment-methods');
      })
      .catch(err => {
        toast.error(err.response?.data?.error || 'Não foi possível cadastrar a forma de recebimento');
      })
      .finally(() => setSaving(false));
  }

  function handleValidation(e?: FormEvent<HTMLFormElement>) {
    e?.preventDefault();

    const found = validatePaymentMethod(paymentMethod);
    setErrors(found);
    if (Object.keys(found).length > 0) return;

    handleSubmit();
  }

  return (
    <>
      <Appbar title="Formas de recebimento" backAction={goBack} />

      {saving && <InsideSaving />}

      <PageShell>
        <RecordHeader title="Nova forma de recebimento" backAction={goBack} />

        <WorkArea>
          <ContentPad>
            <StyledForm onSubmit={handleValidation}>
              <PaymentMethodForm handleChange={handleChange} paymentMethod={paymentMethod} errors={errors} />
              <button type="submit" style={{ display: 'none' }}></button>
            </StyledForm>
          </ContentPad>
        </WorkArea>

        <RecordFooter>
          <Button variant="contained" size="small" disabled={saving} onClick={() => handleValidation()}>
            Salvar forma
          </Button>
        </RecordFooter>
      </PageShell>
    </>
  );
};

export default NewPaymentMethod;
